module.exports = __webpack_public_path__ + "static/media/Inventor + Generative Design.211f4b89.png";